import React from 'react';

const CareerView = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Header Section - Updated to match Contact Us page */}
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 text-center py-16 px-4">
        <h1 className="text-4xl font-bold text-white mb-2">Careers</h1>
        <p className="text-teal-100 max-w-2xl mx-auto">
          Join us in revolutionizing the future of mobile app development
        </p>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-24">
        <div className="bg-gradient-to-br from-zinc-900 to-zinc-800 rounded-3xl p-12 border border-zinc-700 text-center relative overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal-500 via-cyan-500 to-blue-500"></div>
          <div className="absolute top-2 left-0 w-full h-1 bg-gradient-to-r from-teal-500 via-cyan-500 to-blue-500 opacity-30"></div>
          
          <div className="relative z-10">
            <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-cyan-400 mb-6">
              Career Opportunities
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              We're building a team of exceptional individuals who are passionate about mobile development and innovation. If you're excited about shaping the future of app publishing, we'd love to hear from you.
            </p>
            
            <div className="space-y-8">
              <div className="bg-black/30 rounded-xl p-6 max-w-xl mx-auto">
                <h3 className="text-xl font-semibold text-white mb-4">Why Join Us?</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                  <div className="flex items-center space-x-2">
                    <span className="text-teal-400">●</span>
                    <span>Work on cutting-edge tech</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-teal-400">●</span>
                    <span>Flexible remote culture</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-teal-400">●</span>
                    <span>Growing startup environment</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-teal-400">●</span>
                    <span>Impactful work at scale</span>
                  </div>
                </div>
              </div>
              
              <div className="inline-block">
                <a 
                  href="mailto:davidd@elef89.com" 
                  className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-lg hover:from-teal-600 hover:to-cyan-600 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Join Our Team
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerView; 